"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputEmail = void 0;
var estiloTextfield = require("./InputEmail.module.scss");
var react_1 = __importStar(require("react"));
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var HelperText_1 = require("../../HelperText/HelperText");
var Label_1 = require("../../Label/Label");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)([a-zA-Z0-9_%+-]+(?:\.[a-zA-Z0-9_%+-]+)*)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
var InputEmail = function (_a) {
    var id = _a.id, _b = _a.placeholder, placeholder = _b === void 0 ? "Digite seu email..." : _b, valor = _a.valor, _c = _a.label, label = _c === void 0 ? false : _c, _d = _a.textoLabel, textoLabel = _d === void 0 ? "Email:" : _d, _e = _a.variante, variante = _e === void 0 ? "regular" : _e, _f = _a.desabilitado, desabilitado = _f === void 0 ? false : _f, _g = _a.tamanho, tamanho = _g === void 0 ? "medium" : _g, _h = _a.readonly, readonly = _h === void 0 ? false : _h, _j = _a.botaoDeLimpar, botaoDeLimpar = _j === void 0 ? true : _j, conteudoAjuda = _a.conteudoAjuda, style = _a.style, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, onKeyUp = _a.onKeyUp, onKeyDown = _a.onKeyDown;
    //#region States
    var _k = (0, react_1.useState)(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600), cor = _k[0], setCor = _k[1];
    var _l = (0, react_1.useState)(valor || ""), inputValue = _l[0], setInputValue = _l[1];
    var _m = (0, react_1.useState)(variante), varianteState = _m[0], setVarianteState = _m[1];
    var _o = (0, react_1.useState)(tamanho === "small" ? "16px" : "20px"), iconeSize = _o[0], setIconeSize = _o[1];
    var _p = (0, react_1.useState)(conteudoAjuda || undefined), conteudoAjudaState = _p[0], setConteudoAjudaState = _p[1];
    //#region Variaveis
    var inputFieldSize = estiloTextfield[tamanho] || "";
    var disabledStyle = estiloTextfield.disabled || "";
    var estiloVariacao = estiloTextfield[varianteState] || estiloTextfield["regular"];
    var inputfieldStyle = desabilitado ? disabledStyle : estiloVariacao;
    //#region Handlers
    var handleChange = function (event) {
        setInputValue(event.target.value);
        onChange && onChange(event.target.value);
    };
    var handleFocus = function (event) {
        onFocus && onFocus(event);
    };
    var handleBlur = function (event) {
        var value = event.target.value;
        if (value === "") {
            setVarianteState("error");
            return setConteudoAjudaState({
                texto: "Insira um e-mail.",
                icone: "warning",
                estado: "error",
            });
        }
        else {
            setVarianteState("regular");
            setConteudoAjudaState(undefined);
        }
        var isValidEmail = emailRegex.test(value);
        if (!isValidEmail) {
            setVarianteState("error");
            return setConteudoAjudaState({
                texto: "E-mail inválido.",
                icone: "warning",
                estado: "error",
            });
        }
        else {
            setVarianteState("regular");
            setConteudoAjudaState(undefined);
        }
        onBlur && onBlur(event);
    };
    var limparCampo = function () {
        setInputValue("");
        onChange && onChange(null);
    };
    //#region UseEffects
    (0, react_1.useEffect)(function () {
        setInputValue(valor !== null && valor !== void 0 ? valor : "");
    }, [valor]);
    (0, react_1.useEffect)(function () {
        setIconeSize(tamanho === "small" ? "16px" : "20px");
    }, [tamanho]);
    (0, react_1.useEffect)(function () {
        if (desabilitado) {
            setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU400);
        }
        else if (conteudoAjuda === undefined) {
            setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
        }
        else {
            switch (variante) {
                case "success":
                    setCor(Cores_1.Cores.MensagensDoSistema.VerdeMU);
                    break;
                case "error":
                    setCor(Cores_1.Cores.MensagensDoSistema.VermelhoMU);
                    break;
                case "regular":
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
                    break;
                default:
                    setCor(Cores_1.Cores.GradacaoNeutros.CinzaFillMU600);
                    break;
            }
        }
    }, [variante, desabilitado, conteudoAjuda]);
    (0, react_1.useEffect)(function () {
        setVarianteState(variante);
    }, [variante]);
    (0, react_1.useEffect)(function () {
        setConteudoAjudaState(conteudoAjuda || undefined);
        setVarianteState((conteudoAjuda === null || conteudoAjuda === void 0 ? void 0 : conteudoAjuda.estado) || "regular");
    }, [conteudoAjuda]);
    //#region Render
    return (react_1.default.createElement("div", { className: estiloTextfield.container, style: __assign(__assign({}, style), { gap: "".concat(conteudoAjudaState ? "8px" : "0px") }) },
        react_1.default.createElement("div", { className: estiloTextfield.conteudo },
            label && react_1.default.createElement(Label_1.Label, { texto: textoLabel }),
            react_1.default.createElement("div", { className: "".concat(estiloTextfield.input, " ").concat(inputFieldSize, " ").concat(inputfieldStyle) },
                react_1.default.createElement("input", { type: "email", id: id, value: inputValue, placeholder: placeholder, onChange: handleChange, onBlur: handleBlur, disabled: desabilitado, readOnly: readonly, onFocus: handleFocus, onKeyUp: onKeyUp, onKeyDown: onKeyDown }),
                botaoDeLimpar && !globalMu_1.default.isNullOrEmpty(inputValue) && (react_1.default.createElement("div", { onClick: limparCampo, className: "\n                                ".concat(estiloTextfield.botaoLimpar, " \n                                ").concat(inputFieldSize, " \n                                ").concat(desabilitado ? disabledStyle : "", "\n                            ") },
                    react_1.default.createElement(Icone_1.Icone, { nome: "close", largura: iconeSize, altura: iconeSize, desabilitado: desabilitado, cor: cor, corOnHover: Cores_1.Cores.MensagensDoSistema.VermelhoMU }))))),
        conteudoAjudaState && (react_1.default.createElement(HelperText_1.HelperText, __assign({}, conteudoAjudaState, { key: "helper-text-input-email-".concat(id), estado: varianteState, desabilitado: desabilitado })))));
};
exports.InputEmail = InputEmail;
